import React, {Component} from 'react'
import style from './ResultRatingList/resultRatingList.module.scss'
import Number from '../../../../core/utils/Number'

class OnlineCounter extends Component {
   initOnlineNumberUpdater() {
      setInterval(() => {
         const currentValue = parseInt(document.querySelector('#jsOnlineMarker').textContent)
         const toAdd = Number.getRandomInt(0, 8)
         document.querySelector('#jsOnlineMarker').textContent = (Number.getRandomInt(0, 10) > 4
            ? currentValue + toAdd : currentValue - toAdd).toString()
      }, Number.getRandomInt(11, 30) * 100)
   }

   render() {
      this.initOnlineNumberUpdater()
      const {online} = this.props
      return (
         <b id='jsOnlineMarker' className={style.resultRatingList__ratingNumber}>{online}</b>
      )
   }
}

export default OnlineCounter